import { ProgressReportMasterDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgressMasterService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getProgressMaster(): Observable<ProgressReportMasterDto[]> {
    return this.http.get<ProgressReportMasterDto[]>(
      this.url + 'project-report-master'
    );
  }

  createProgressMaster(
    data: ProgressReportMasterDto[]
  ): Observable<ProgressReportMasterDto[]> {
    return this.http.post<ProgressReportMasterDto[]>(
      this.url + 'project-report-master',
      data
    );
  }
  getSingleProgressMaster(id: string): Observable<any> {
    return this.http.get(this.url + 'project-report-master/' + id);
  }

  updateProgressMaster(
    data: ProgressReportMasterDto[]
  ): Observable<ProgressReportMasterDto[]> {
    return this.http.post<ProgressReportMasterDto[]>(
      this.url + 'project-report-master/update',
      data
    );
  }

  deleteProgressMaster(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('project-report-master', ids.join(', '));
    return this.http.delete(this.url + 'project-report-master', httpOptions);
  }
}
